/*global _, addiesaas */

const F = {
  CARDS: `playcard.cards`,
}

export default (Bus) => {
  Bus.add(F.CARDS, decorateCards)
}

const decorateCards = ({cards}) => {
  const formatters = addiesaas.$fn.formatters
  _.forOwn(cards, card => {
    const maskedNumber = card.maskedNumber
    if (!maskedNumber) {
      const number = card.number
      const formattedNumber = formatters.maskLeft(number, 'XXXXXX0000', {clip: true})
      const cardMember = _.get(card, 'family_member.data')
      let memberName = ''
      if (cardMember) {
        memberName = _.filter([cardMember.first_name, cardMember.last_name]).join(' ')
      }
      card.maskedNumber = _.filter([memberName, formattedNumber]).join(' - ')
      card.points_rounded = _.floor(_.toFinite(card.points))
      card.bonus_points_rounded = _.floor(_.toFinite(card.bonus_points))
      card.tickets_rounded = _.floor(_.toFinite(card.tickets_rounded))
    }
  })
}
